import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { Mutations } from 'api/mutations.enum'
import {
    GetPulseSurveyCollectorInfoParams,
    GetPulseSurveyCollectorInfoResponse,
} from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { getPulseSurveyCollectorInfo } from 'api/actions/pulseSurveys/pulseSurveysActions'

export const useGetPulseSurveyCollectorInfo = () => {
    const mutation = useMutation<
        GetPulseSurveyCollectorInfoResponse,
        AxiosError<{
            detail: string
        }>,
        GetPulseSurveyCollectorInfoParams
    >({
        mutationFn: getPulseSurveyCollectorInfo,
        mutationKey: [Mutations.getPulseSurveyCollectorInfo],
    })

    return mutation
}
